import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";
import { NumberLiteralType } from "typescript";


export class committeemember extends EntityDto implements IEntityDto {
  Member_Id: string;
  Committee_Id: string;
  CommitteeName: string;
  Emp_Ref_Id: string|undefined;
  EmployeeName: string|undefined;
  JoiningDate: Date;
  JoiningDateStr: string | null = "";
  MemberInChargeTill_Id: number;
  MembershipExpiryDate: Date;
  MembershipExpiryDateStr: string | null = "";
  TenureDate:string;
  MembershipExpiryTenure: number;
  Membername: string;
  MembershipExpiryType: string;
  MembershipExpiry_Id: number;
  SittingFeeApplicable: boolean;
  SittingFee: number;
  SittingFeeEffectiveFrom: Date|undefined;
  SittingFeeEffectiveFromStr: string | null ="";
  SittingFeeEffectiveTo: Date|undefined;
  SittingFeeEffectiveToStr: string | null = "";
  MemberJoiningDate: Date ;
  MemberJoiningDateStr: string;
  MemberInChargeTillDate: Date | null;
  MemberInChargeTillDateStr: string | null = "";
  MemberInChargeTillTenure: number;
  MemberInChargeTillTenureDate: string|null='';
  MemberEditBit:number;
  Mode: number;
  UserName: string;

  constructor() {
    super();
    this.Member_Id = '00000000-0000-0000-0000-000000000000';
    this.Committee_Id = '00000000-0000-0000-0000-000000000000';
    this.CommitteeName = '';
    this.Emp_Ref_Id = '';
    // this.JoiningDate = new Date();
    this.JoiningDate = new Date();
    this.MemberInChargeTill_Id = 0;
    this.MembershipExpiryDate = new Date();
    this.MembershipExpiryTenure = 0;
    this.TenureDate='';
    this.Membername = '';
    this.MembershipExpiryType = '';
    this.MembershipExpiry_Id = 0;
    this.MemberJoiningDateStr="";
    this.EmployeeName = '';
    this.SittingFeeApplicable =false ;
    this.SittingFee = 0.00;
    this.MemberJoiningDate = new Date();
    this.MemberInChargeTillDate = null;
    this.MemberInChargeTillTenure = 0;
    this.Mode = 0;
    this.UserName = "";
    this.JoiningDateStr="";
    this.SittingFeeEffectiveFromStr="";
    this.MemberEditBit=0;
// this.MemberInChargeTillTenureDate=new Date();
    this.EntityMetaData = [
      // { FieldName: 'CommitteeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Committee is required' },
      // { FieldName: 'Department_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department Name is required' },
      { FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Member is required' },
      // { FieldName: 'MemberJoiningDate', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Joining Date is required' },


    ];
  }
}